import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface DashboardConfirmDialogData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  standalone: true,
  selector: 'app-dashboard-confirm-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <h2 mat-dialog-title class="text-lg font-medium">{{ data.title }}</h2>
    <mat-dialog-content class="text-sm text-slate-600 dark:text-slate-300">
      {{ data.message }}
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2">
      <button mat-button type="button" mat-dialog-close>
        {{ data.cancelLabel || 'Cancel' }}
      </button>
      <button mat-flat-button color="primary" type="button" [mat-dialog-close]="true">
        {{ data.confirmLabel || 'OK' }}
      </button>
    </mat-dialog-actions>
  `,
})
export class DashboardConfirmDialogComponent {
  data = inject<DashboardConfirmDialogData>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<DashboardConfirmDialogComponent>);
}
